import React from 'react';
import './App.css';
import Home from './components/Home';
import { ThemeProvider } from "@mui/material";
import theme from "./theme";
import { HelmetProvider } from "react-helmet-async";

function App() {
  return (
    <HelmetProvider>
      <ThemeProvider theme={theme}> 
        <div className="App">
          <Home />
        </div> 
      </ThemeProvider>
    </HelmetProvider>
  );
}

export default App;